import { ColumnDirective, ColumnsDirective, GridComponent, Inject, Page, Sort } from "@syncfusion/ej2-react-grids";

const GradableModelsList = ({ gradableModels, setEdit, setEditableGradableModel }) => {

    const handleEdit = (gradableModel) => {
        setEdit(true);
        setEditableGradableModel(gradableModel);
    }

    return (
        <GridComponent dataSource={gradableModels} allowSorting allowPaging pageSettings={{ pageSize: 30 }}>
            <ColumnsDirective>
                <ColumnDirective field='game' headerText="Jogo" width='100' textAlign="Center" />
                <ColumnDirective field='name' headerText="Nome" width='100' textAlign="Center" />
                <ColumnDirective field='edition' width='100' headerText="Edição" textAlign="Center" />
                <ColumnDirective field='year' width='100' headerText="Ano" textAlign="Center" />
                <ColumnDirective field='language' width='100' headerText="Idioma" textAlign="Center" />
                <ColumnDirective field='numbering' width='100' headerText="Numeração" textAlign="Center" />
                <ColumnDirective field='rarity' width='100' headerText="Raridade" textAlign="Center" />
                <ColumnDirective width='100' textAlign="Center" template={(d, f) => { return <button onClick={() => handleEdit(d)} className="bg-blue-500 hover:bg-blue-800 px-2 text-black">Ver</button> }} />
            </ColumnsDirective>
            <Inject services={[Sort, Page]} />
        </GridComponent>
    )
}

export default GradableModelsList;
